<div>
    <div class="modal-header">
        <h5 class="mb-0">{{ title | translate }}</h5>
    </div>
    <div class="modal-body">
        <form class="k-form k-form-md" [formGroup]="form">
            <div class="mb-1 row">
                <div class="col-12 col-md-4 col-xl-4">
                    <app-label controlName="key" class="col-form-label">{{ 'common.key' | translate }}</app-label>
                </div>
                <div class="col-12 col-md-8 col-xl-8">
                    <input type="text" id="key" formControlName="key" class="form-control" />
                </div>
            </div>
            <div class="mb-1 row">
                <div class="col-12 col-md-4 col-xl-4">
                    <app-label controlName="type" class="col-form-label">{{ 'common.type' | translate }}</app-label>
                </div>
                <div class="col-12 col-md-8 col-xl-8">
                    <input type="text" id="type" formControlName="type" class="form-control" />
                </div>
            </div>
            <div formArrayName="languageList">
                <div class="mb-1 row" *ngFor="let languageControl of getLanguageValueFormArray(); let i = index" [formGroupName]="i">
                    <div class="col-12 col-md-4 col-xl-12">
                        <app-label class="col-form-label"> {{ this.form.get("languageList").value[i].languageCode }}</app-label>
                    </div>
                    <div class="col-12 col-md-8 col-xl-12">
                        <input type="hidden" formControlName="languageCode">
                        <textarea rows="2" class="form-control" formControlName="languageValue"></textarea>
                        <app-field-error-message controlName="languageValue"></app-field-error-message>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button type="submit" [appClickWait]="onSave" class="btn btn-primary" themeColor="primary">
            {{ 'common.save' | translate}}
        </button>
        <button class="btn btn-secondary" (click)="onClose()">{{ 'common.cancel' | translate }}</button>
    </div>
</div>
